import * as React from 'react';
import * as ReactDOM from 'react-dom';

import activity from 'activity';
import rootStudentController from 'root-student-controller';
import _ from 'underscore';
import user from 'user';

import StudentTeamModel from 'StudentTeamModel';
import view from 'StudentTeamView';

import { ErrorView } from '../../../shared/error/ErrorView';

let model = null;

function StudentTeamController() {}

StudentTeamController.prototype = _.extend(
  Object.create(Object.getPrototypeOf(rootStudentController)),
  {
    doTeam: function() {
      if (!controller.shouldDoTeam()) {
        controller.doNextRoute();
      } else {
        model = new StudentTeamModel();
        controller.renderView();
      }
    },

    renderView: function() {
      let comp = React.createElement(view, {
        controller: controller,
        model: model,
        teamCount: activity.get('settings').team_count,
      });
      ReactDOM.render(
        <ErrorView>{comp}</ErrorView>,
        document.getElementById('main-content')
      );
    },

    teamChanged: function(team) {
      model.selectedTeam = team;
      controller.renderView();
    },

    startRacingClicked: function() {
      model.startAttempted = true;
      if (model.isValidSelectedTeam()) {
        user.set('team', model.selectedTeam); // The user model has a 'change' listener that updates the cookie.
        controller.doNextRoute();
      } else {
        controller.renderView();
      }
    },
  }
);

let controller = new StudentTeamController();
module.exports = controller;
